import React from 'react';
import { NavLink } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Tab = styled(NavLink) `
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  font-weight: 900;
  padding: 7px 12px;
  border-radius: 3px;
  color: ${THEME.TEXT_MUTED};
  font-size: 0.85em;

  &:hover {
    background-color: #b8bbbe;
    color: inherit;
  }

  &:active,
  &:visited,
  &:focus {
    text-decoration: none !important;
  }
`;
const TabList = styled.div `
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  padding: 5px;
  margin-bottom: ${THEME.GRID_SPACING}px;
  background-color: ${THEME.FILL};
  border-radius: 3px;

  & > a.active {
    background-color: ${THEME.COLOR_SECONDARY};
    color: ${THEME.COLOR_ACCENT};
  }
`;
const SubTabs = (props) => {
    return (React.createElement(TabList, null, props.items.map((item) => (React.createElement(Tab, { to: item.link, key: item.link, exact: item.exact === false ? false : true }, item.label)))));
};
export default SubTabs;
//# sourceMappingURL=SubTabs.js.map